import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BackLink from "@/components/BackLink";
import PendingDraftBanner from "@/components/PendingDraftBanner";
import PostCreateGalleri from "@/components/PostCreateGalleri";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
function modHeaders() { return { Authorization: `Bearer ${sessionStorage.getItem("mod_token")}` }; }

export default function ModCreateVardagskort() {
  const navigate = useNavigate();
  // Etappe 4.2 — defaulta andrad_av till inloggad användare
  const user = JSON.parse(sessionStorage.getItem("mod_user") || "null");
  const [form, setForm] = useState({ rubrik: "", beskrivning: "", omrade: "Handla & vardag", ort: "", kontakt_telefon: "", kontakt_epost: "", extern_lank: "", kalltext: "", publish: true, andrad_av: (user?.name || user?.email || "").trim(), andringsnotering: "" });
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const [savedId, setSavedId] = useState(null); // Build 96.21

  const set = (f, v) => { setForm(p => ({ ...p, [f]: v })); if (errors[f]) setErrors(p => ({ ...p, [f]: null })); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.rubrik.trim()) errs.rubrik = "Ange rubrik";
    if (!form.beskrivning.trim()) errs.beskrivning = "Ange beskrivning";
    // Etappe 4.2 — Ändrad av Pflicht
    if (!form.andrad_av.trim()) errs.andrad_av = "Ange namn på den som ändrar posten innan du sparar.";
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    setBusy(true);
    try {
      const res = await axios.post(`${API}/mod/vardagskort/create`, {
        ...form,
        kontakt_telefon: form.kontakt_telefon || null,
        kontakt_epost: form.kontakt_epost || null,
        extern_lank: form.extern_lank || null,
        kalltext: form.kalltext || null,
        ort: form.ort || null,
        andrad_av: form.andrad_av.trim(),
        andringsnotering: form.andringsnotering || null,
      }, { headers: modHeaders() });
      setSavedId(res.data.id); // Build 96.21
    } catch (err) { if (err.response?.status === 401) navigate("/mod/login"); else setErrors({ submit: err?.response?.data?.detail || "Något gick fel" }); }
    setBusy(false);
  };

  if (savedId) {
    return (
      <div data-testid="mod-create-vardagskort-success" className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
        <BackLink to="/mod/praktiskt" label="Praktiskt i bygden" />
        <PostCreateGalleri
          collection="vardagskort"
          itemId={savedId}
          titel={form.rubrik}
          backTo="/mod/praktiskt"
          backLabel="Tillbaka till Praktiskt"
          publikt={form.publish}
        />
      </div>
    );
  }

  return (
    <div data-testid="mod-create-vardagskort" className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
      <BackLink to="/mod/praktiskt" label="Praktiskt i bygden" />
      <PendingDraftBanner urlPattern="/api/mod/vardagskort" />
      <h1 className="font-heading text-2xl font-medium text-ink mb-6">Nytt vardagskort</h1>
      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <Field label="Rubrik" error={errors.rubrik} required><input value={form.rubrik} onChange={e => set("rubrik", e.target.value)} className="input-mod" /></Field>
        <Field label="Beskrivning" error={errors.beskrivning} required><textarea value={form.beskrivning} onChange={e => set("beskrivning", e.target.value)} rows={3} className="input-mod" /></Field>
        <Field label="Område" required>
          <select value={form.omrade} onChange={e => set("omrade", e.target.value)} className="input-mod">
            <option>Handla & vardag</option><option>Service & fordon</option><option>Vård & trygghet</option>
          </select>
        </Field>
        <Field label="Ort"><input value={form.ort} onChange={e => set("ort", e.target.value)} className="input-mod" placeholder="T.ex. Backe" /></Field>
        <Field label="Kontakt telefon"><input value={form.kontakt_telefon} onChange={e => set("kontakt_telefon", e.target.value)} className="input-mod" /></Field>
        <Field label="Kontakt e-post"><input value={form.kontakt_epost} onChange={e => set("kontakt_epost", e.target.value)} className="input-mod" /></Field>
        <Field label="Extern länk"><input value={form.extern_lank} onChange={e => set("extern_lank", e.target.value)} className="input-mod" placeholder="https://..." /></Field>
        <Field label="Källa"><input value={form.kalltext} onChange={e => set("kalltext", e.target.value)} className="input-mod" placeholder="T.ex. 1177.se" /></Field>
        {/* Etappe 4.2 — Pflicht-Audit-Felder */}
        <Field label="Ändrad av" error={errors.andrad_av} required>
          <input data-testid="vardagskort-andrad-av" value={form.andrad_av} onChange={e => set("andrad_av", e.target.value)} className="input-mod" placeholder="Ange namn på den som ändrar posten" />
        </Field>
        <Field label="Ändringsnotering (valfritt)">
          <input value={form.andringsnotering} onChange={e => set("andringsnotering", e.target.value)} className="input-mod" placeholder="Kort kommentar om vad som ändrades" />
        </Field>
        <div className="flex items-center gap-3"><input type="checkbox" checked={form.publish} onChange={e => set("publish", e.target.checked)} className="w-5 h-5 accent-pine" /><label className="text-base text-ink">Publicera direkt</label></div>
        {errors.submit && <p className="text-falu">{errors.submit}</p>}
        <button type="submit" disabled={busy} data-testid="vardagskort-submit" className="bg-pine hover:bg-pine-hover text-white font-medium px-6 py-3 rounded-md text-base transition-colors disabled:opacity-50 w-fit">{busy ? "Sparar..." : "Skapa"}</button>
      </form>
    </div>
  );
}

function Field({ label, error, required, children }) {
  return (<div><label className="block text-sm font-medium text-ink mb-1">{label}{required && <span className="text-falu ml-1">*</span>}</label>{children}{error && <p className="text-falu text-sm mt-1">{error}</p>}</div>);
}
